var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBsdRightHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 350,
    viewBox: "0 0 347 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_402_817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.671 191.913C285.695 189.94 295.961 176.4 295.961 176.4C295.961 176.4 295.6 169.976 294.887 168.211C294.173 166.446 291.686 164.602 290.122 163.856C288.558 163.11 285.005 163.142 285.005 163.142C285.005 163.142 285.366 175.662 285.157 176.866C284.949 178.069 283.673 178.349 283.673 178.349H286.898C282.831 184.67 274.658 191.913 274.658 191.913L273.07 192.53C273.07 192.53 272.556 199.236 273.527 201.281C274.497 203.326 281.692 206.07 281.973 206.302C282.254 206.535 282.791 205.997 282.791 205.997L283.2 196.629L285.671 191.913ZM285.671 191.913C288.719 194.295 292.208 198.009 292.208 198.009C302.105 218.285 298.969 257.532 298.969 257.532H293.852C293.852 257.532 294.943 262.071 294.943 262.039C294.943 262.007 299.996 262.039 299.996 262.039C299.996 262.039 303.132 268.729 302.996 287.49C302.859 306.25 292.889 328.115 292.889 328.115H253.162C253.162 328.115 263.814 311.28 263.405 295.599C262.996 279.918 259.274 267.806 256.779 262.994H263.814C263.814 262.994 269.853 269.242 270.848 284.225C271.835 299.208 270.439 312.555 270.439 312.555C270.439 312.555 295.536 306.756 302.049 298.013",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.844 257.532H259.507L263.806 262.994L294.935 262.031",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.507 257.532C259.507 257.532 241.026 228.52 200.73 239.781M184.76 157.046C184.76 157.046 217.237 157.688 279.382 187.365",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.729 239.781L194.794 242.958H158.034L169.199 228.007L169.809 199.741L168.686 175.173L169.095 162.572L167.355 157.046H184.76",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.658 99.4082H165.991C165.991 99.4082 169.127 99.5766 169.127 102.344C169.127 105.111 169.127 155.201 169.127 155.201L167.355 157.046L154.658 156.701V99.4082Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.991 99.4082C165.991 99.4082 171.758 98.7264 171.726 102.825C171.694 106.924 171.726 151.728 171.726 151.728L169.135 155.209",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.589 157.046L171.718 151.72",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.354 157.046L164.355 168.925C164.355 168.925 159.815 173.184 153.502 170.457C147.19 167.73 152.067 164.209 152.067 164.209L153.446 161.859L156.438 156.757",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.686 175.174L139.57 171.725C140.525 168.171 151.176 161.859 151.176 161.859H153.446",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.135 161.851H168.686",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.794 242.958C194.794 242.958 183.597 247.153 174.79 260.949C165.983 274.737 166.737 291.26 166.737 291.26V328.124H-135.803V234.456H-147V-2L-75.5981 0.24585C-75.5981 0.24585 -7.19596 4.95411 47.6829 26.1212C102.562 47.2883 125.437 80.6632 125.437 80.6632L143.38 106.138L154.657 124.217",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-73.4085 0.414062L-85.1511 62.4315H100.075C100.075 62.4315 105.257 62.8085 110.551 70.5086",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84.5414 234.937H65.9785",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.471 245.204H33.4859C33.4859 245.204 31.9861 235.972 29.291 234.929",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4443 234.937C14.4443 234.937 10.9633 238.955 10.9633 245.212H-81.4613L-84.5334 234.937",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4858 245.204L32.3228 260.941C32.3228 260.941 31.0956 265.24 29.2829 265.312C27.4702 265.384 15.2544 265.312 15.2544 265.312C15.2544 265.312 12.7599 264.598 11.9738 260.74C11.1878 256.882 10.9472 245.212 10.9472 245.212",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2776 244.153L27.6146 261.149H16.8988L13.7626 244.153L15.9443 237.6H28.1681L30.2776 244.153Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7627 244.153H10.9634",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2775 244.153H33.4858",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.5 269.275C170.5 269.275 171 269.275 161.002 269.275H38.9482V245.212",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9482 269.274V328.116",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9482 304.494L154.657 305.312V297.123H38.9482H-135.803",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.631 245.204C153.631 245.204 147.76 254.115 145.987 262.031H38.9483H31.9541",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6076 262.032V245.204L65.9786 234.937H164.026",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.584 336.289C190.432 336.289 170.042 315.899 170.042 290.746C170.042 265.594 190.432 245.204 215.584 245.204C240.737 245.204 261.127 265.594 261.127 290.746C261.127 315.899 240.737 336.289 215.584 336.289Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.584 316.493C201.364 316.493 189.837 304.966 189.837 290.746C189.837 276.526 201.364 264.999 215.584 264.999C229.804 264.999 241.331 276.526 241.331 290.746C241.331 304.966 229.804 316.493 215.584 316.493Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.584 332.278C192.647 332.278 174.052 313.684 174.052 290.746C174.052 267.808 192.647 249.214 215.584 249.214C238.522 249.214 257.116 267.808 257.116 290.746C257.116 313.684 238.522 332.278 215.584 332.278Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.584 312.868C203.367 312.868 193.462 302.964 193.462 290.746C193.462 278.529 203.367 268.625 215.584 268.625C227.801 268.625 237.706 278.529 237.706 290.746C237.706 302.964 227.801 312.868 215.584 312.868Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.584 297.941C211.611 297.941 208.389 294.72 208.389 290.746C208.389 286.772 211.611 283.551 215.584 283.551C219.558 283.551 222.779 286.772 222.779 290.746C222.779 294.72 219.558 297.941 215.584 297.941Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.145 72.1289L154.657 153.356",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.826 73.1796H51.8538C51.8538 73.1796 44.0895 71.5835 40.424 79.0028C40.424 79.0028 40.1673 109.787 44.5146 122.5C44.5146 122.5 45.1964 129.582 54.4044 131.203C63.6124 132.823 120.416 136.488 120.416 136.488C120.416 136.488 128.774 136.745 129.119 130.858L124.338 106.466",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.307 101.766C121.307 101.766 125.967 116.316 126.56 130.088C126.56 130.088 127.074 134.307 122.895 134.355C122.895 134.355 66.3075 131.58 54.6692 128.941C54.6692 128.941 49.0385 128.644 46.3114 120.623C46.3114 120.623 41.7475 89.2778 42.5576 80.9682C42.5576 80.9682 42.4293 77.1342 48.8541 74.6558H103.853",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9692 199.645C86.9692 199.645 81.2584 194.528 73.5022 199.645L74.3764 219.152L80.2397 221.919L86.103 219.152L86.9692 199.645Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7317 203.022H81.8037V219.505H78.7317V203.022Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8037 204.762L84.7715 206.398V217.612H81.4909",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7317 204.762L75.6035 206.35V217.612H78.7317",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2398 201.899C79.2076 201.899 78.3709 201.062 78.3709 200.03C78.3709 198.998 79.2076 198.161 80.2398 198.161C81.2719 198.161 82.1086 198.998 82.1086 200.03C82.1086 201.062 81.2719 201.899 80.2398 201.899Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.57 234.456L137.661 240.07H60.1473H32.2827",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7654 240.07H-83.0013",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.673 178.341H281.043C281.043 178.341 279.952 178.133 279.783 176.906C279.615 175.679 279.783 164.923 279.783 164.923C279.783 164.923 279.631 163.27 281.524 163.134C283.417 162.997 285.005 163.134 285.005 163.134",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.898 178.342H289.713C289.713 178.342 290.635 178.623 289.713 179.978C288.791 181.334 275.989 196.87 275.989 196.87C275.989 196.87 274.69 198.129 275.059 202.773",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.737 314.015H-135.803",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.584 277.343C213.737 277.343 212.239 275.846 212.239 273.999C212.239 272.151 213.737 270.654 215.584 270.654C217.431 270.654 218.929 272.151 218.929 273.999C218.929 275.846 217.431 277.343 215.584 277.343Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.371 294.091C196.524 294.091 195.027 292.593 195.027 290.746C195.027 288.899 196.524 287.401 198.371 287.401C200.219 287.401 201.716 288.899 201.716 290.746C201.716 292.593 200.219 294.091 198.371 294.091Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.284 294.091C230.436 294.091 228.939 292.593 228.939 290.746C228.939 288.899 230.436 287.401 232.284 287.401C234.131 287.401 235.628 288.899 235.628 290.746C235.628 292.593 234.131 294.091 232.284 294.091Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.584 310.838C213.737 310.838 212.239 309.341 212.239 307.494C212.239 305.646 213.737 304.149 215.584 304.149C217.431 304.149 218.929 305.646 218.929 307.494C218.929 309.341 217.431 310.838 215.584 310.838Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.323 305.312C202.476 305.312 200.978 303.815 200.978 301.967C200.978 300.12 202.476 298.623 204.323 298.623C206.17 298.623 207.667 300.12 207.667 301.967C207.667 303.815 206.17 305.312 204.323 305.312Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.118 283.199C225.271 283.199 223.773 281.701 223.773 279.854C223.773 278.007 225.271 276.509 227.118 276.509C228.965 276.509 230.463 278.007 230.463 279.854C230.463 281.701 228.965 283.199 227.118 283.199Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.513 283.199C201.665 283.199 200.168 281.701 200.168 279.854C200.168 278.007 201.665 276.509 203.513 276.509C205.36 276.509 206.857 278.007 206.857 279.854C206.857 281.701 205.36 283.199 203.513 283.199Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.118 304.983C225.271 304.983 223.773 303.486 223.773 301.639C223.773 299.791 225.271 298.294 227.118 298.294C228.965 298.294 230.463 299.791 230.463 301.639C230.463 303.486 228.965 304.983 227.118 304.983Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.145 72.1289L98.6396 66.7549L100.067 66.7629C100.067 66.7629 107.102 66.4581 110.543 70.5167L154.649 134.66",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6477 66.7471H46.6563C42.3972 66.7471 38.9483 70.196 38.9483 74.4551V234.937",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6562 66.7471C46.6562 66.7471 36.9029 67.0599 36.4938 72.0168C36.0847 76.9737 36.4938 234.929 36.4938 234.929",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0356 56.4963C94.0356 56.4963 54.3964 28.0623 7.00102 18.2046",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.586 335.414C188.367 336.195 189.633 336.195 190.414 335.414L203.142 322.686C203.923 321.905 203.923 320.639 203.142 319.858C202.361 319.077 201.095 319.077 200.313 319.858L189 331.172L177.686 319.858C176.905 319.077 175.639 319.077 174.858 319.858C174.077 320.639 174.077 321.905 174.858 322.686L187.586 335.414ZM190.414 222.086C189.633 221.305 188.367 221.305 187.586 222.086L174.858 234.814C174.077 235.595 174.077 236.861 174.858 237.642C175.639 238.423 176.905 238.423 177.686 237.642L189 226.328L200.313 237.642C201.095 238.423 202.361 238.423 203.142 237.642C203.923 236.861 203.923 235.595 203.142 234.814L190.414 222.086ZM191 334L191 223.5L187 223.5L187 334L191 334Z",
    fill: "#2D9DC9"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 347,
    y2: -0.5,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 347 337)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298 251C298 251 297.326 237.05 293.31 228.574C289.285 220.099 282.478 219.607 277 219L283.702 234.996L298 251Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202 205C202 203.895 201.105 203 200 203H178C176.895 203 176 203.895 176 205V219C176 220.105 176.895 221 178 221H200C201.105 221 202 220.105 202 219V205ZM189.473 219.677H188.524C188.288 219.677 188.097 219.485 188.097 219.25V215.752C188.097 215.517 188.288 215.325 188.524 215.325H189.473C189.709 215.325 189.901 215.517 189.901 215.752V219.25C189.901 219.485 189.709 219.677 189.473 219.677ZM188.524 208.681H189.473C189.709 208.681 189.901 208.489 189.901 208.249V204.752C189.901 204.516 189.709 204.325 189.473 204.325H188.524C188.288 204.325 188.097 204.516 188.097 204.752V208.254C188.097 208.489 188.288 208.681 188.524 208.681ZM196.262 212.903H192.756C192.52 212.903 192.328 212.712 192.328 212.476V211.529C192.328 211.294 192.52 211.103 192.756 211.103H196.262C196.498 211.103 196.69 211.294 196.69 211.529V212.476C196.69 212.712 196.498 212.903 196.262 212.903ZM185.668 212.472V211.525C185.668 211.289 185.477 211.098 185.241 211.098H181.734C181.498 211.098 181.307 211.289 181.307 211.525V212.472C181.307 212.707 181.498 212.898 181.734 212.898H185.241C185.477 212.898 185.668 212.707 185.668 212.472ZM194.775 217.094L194.102 217.765C193.933 217.934 193.661 217.934 193.496 217.765L191.015 215.29C190.845 215.121 190.845 214.85 191.015 214.685L191.687 214.014C191.857 213.845 192.128 213.845 192.293 214.014L194.775 216.49C194.94 216.654 194.94 216.925 194.775 217.094ZM185.7 209.988C185.864 210.157 186.136 210.157 186.306 209.988L186.978 209.317C187.148 209.152 187.148 208.881 186.978 208.712L184.497 206.237C184.332 206.068 184.06 206.068 183.891 206.237L183.218 206.908C183.049 207.072 183.049 207.343 183.218 207.512L185.7 209.988Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_402_817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 347,
    height: 350,
    fill: "white",
    transform: "matrix(-1 0 0 1 347 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsdRightHeight);
export default __webpack_public_path__ + "static/media/bsdRightHeight.56869742484b8482aba304d1a02bc173.svg";
export { ForwardRef as ReactComponent };